<template>
  <div class="analyse-container">
    <div class="target" style="text-align: center; margin-top: 15px;">
      <h4>{{ analyseTypeName + '指标分析' }}</h4>
      <el-table
        id="analyse-table"
        stripe
        border
        :data="analyseTarget"
        :header-cell-style="{background:'#f5f7fa'}"
        style="width: 98%!important; display: inline-block"
      >
        <el-table-column
          v-for="(item, key) in analyseShowDimColumn"
          :key="key"
          :label="item"
          show-overflow-tooltip
          align="center"
          min-width="140"
        >
          <template #default="scope">
            {{ key === 'plat_id' ? Number(scope.row[key]) > 8 ? '' : $global.platIdMap.filter(res => {return res.value === Number(scope.row[key])})[0].label || '' :
              // id 与 name 的结合
              key.indexOf('_id') > -1 ? scope.row[key] + (scope.row[key.replace('_id','_name')] ? '-' + scope.row[key.replace('_id','_name')] : '') :
              // 平台转为中文名
              key === 'csite' ? scope.row[key] + '-' + scope.row['csite_name'] :
              key === 'platform' ? $global.platformMap[scope.row['platform']] :
              key === 'device_price_section' ? getPriceSection(scope.row[key]) :
              key === 'is_simulator' || key === 'is_root_reg' ? scope.row[key] === '0' ? '否' : '是' : scope.row[key] }}
          </template>
        </el-table-column>
        <el-table-column label="日期" min-width="150" align="center">
          <template #default="scope">
            {{ getDate(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="消耗" min-width="120" align="center">
          <template #default="scope">
            {{ scope.row.cost }}
          </template>
        </el-table-column>
        <el-table-column v-if="hasNotAbnormality" label="提示" min-width="150" align="center" show-overflow-tooltip>
          {{ analyseTargetTip }}
        </el-table-column>
      </el-table>
    </div>
    <div v-if="!hasNotAbnormality" class="analyse-data" style="text-align: center">
      <h4>异常分析（消耗: {{ allCost }}）</h4>
      <el-table
        id="analyse-table"
        stripe
        border
        :data="analyseDataList"
        :header-cell-style="{background:'#f5f7fa'}"
        style="width: 98%!important; margin-bottom: 20px; display: inline-block"
        row-key="id"
        :expand-row-keys="expands"
        :max-height="560"
        :cell-class-name="cellClassName"
        @expand-change="handleExpand"
        @sort-change="handleAnalyseSortChange"
      >
        <el-table-column type="expand">
          <template #header>操作</template>
          <template #default="props">
            <el-form v-if="!showChart" label-width="130px" label-position="top" inline>
              <el-form-item v-for="(item, key) in props.row.detail" v-show="!!item" :key="key" style="width: 32%; padding: 10px 0 0 10px;">
                <template #label>
                  <svg-icon v-show="hasChart(key, item, props.row.id)" v-track:click="{event_id: 6}" icon-class="line" style="cursor: pointer;" @click="handleShowChart" />
                  {{ analyseList.filter(item => { return item.value === key})[0].label }}
                </template>
                <div style="white-space: pre-wrap; font-size: 12px;" :class="{'chart-form-item': hasChart(key, item, props.row.id)}" v-html="getAnalyseText(item)" />
              </el-form-item>
            </el-form>
            <AnalyseChart v-else :first-data="props.row.item" :mean-data="props.row.average_item" :show-chart.sync="showChart" />
          </template>
        </el-table-column>
        <el-table-column v-for="column in analyseColumn" :key="column.value" :label="column.label" :prop="column.value" align="center" :sortable="column.sortable" :min-width="column.width" show-overflow-tooltip>
          <template #default="scope">
            {{ column.value === 'plat_id' ? Number(scope.row.item[column.value]) > 8 ? '' : $global.platIdMap.filter(res => {return res.value === Number(scope.row.item[column.value])})[0].label || '-' :
              column.value.indexOf('_id') > -1 ? (scope.row.item[column.value] || '-') + (scope.row.item[column.value.replace('_id','_name')] ? '-' + scope.row.item[column.value.replace('_id','_name')] : '') :
              // 平台转为中文名
              column.value === 'csite' ? scope.row.item[column.value] + '-' + scope.row['csite_name'] :
              column.value === 'platform' ? ($global.platformMap[scope.row.item['platform']] || '') :
              column.value === 'device_price_section' ? getPriceSection(scope.row.item[column.value]) :
              column.value === 'is_simulator' || column.value === 'is_root_reg' ? scope.row.item[column.value] === '0' ? '否' : '是' :
              column.label === '日期' ? (scope.row.date_item.date_min === scope.row.date_item.date_max ? scope.row.date_item.date_min : scope.row.date_item.date_min + '至' + scope.row.date_item.date_max):
              column.label === '消耗' ? scope.row.cost.split('(')[0] :
              column.label === '消耗占比' ? scope.row.cost.split('(')[1].replace(')', '') :
              (column.label === '首日回本率' || column.label === '首日付费率') ? (scope.row.item[column.value] * 100).toFixed(2) + '%' :
              column.label === '首日LTV' || column.label === '首日付费成本' ? scope.row.item[column.value].toFixed(2) :
              (scope.row.item[column.value] || '-')
            }}
          </template>
        </el-table-column>
        <el-table-column label="偏差" prop="gap" align="center" sortable="custom">
          <template #default="scope">
            <span style="color: #fff">{{ scope.row.gap }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提示" prop="tip" min-width="150" align="center" show-overflow-tooltip>
          <template #default="scope">
            <div v-html="scope.row.tip" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { deepClone } from '@/utils'
import AnalyseChart from './analyseChart.vue'
import { analyseTracking } from '@/utils/tracking'
export default {
  name: 'TargetAnalyse',
  components: {
    AnalyseChart
  },
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    analyseTypeName: {
      type: String,
      default: ''
    },
    dateMin: {
      type: String,
      default: ''
    },
    dateMax: {
      type: String,
      default: ''
    },
    exceptionData: {
      type: Object,
      default: () => {}
    },
    dimensionColumn: {
      type: Object,
      default: () => {}
    },
    searchAnalyseType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      analyseTarget: null,
      analyseShowDimColumn: {},
      hasNotAbnormality: false,
      allCost: '',
      analyseDataList: [],
      expands: [],
      analyseColumn: [],
      analyseDimColumn: [
        { label: '平台', value: 'platform', filter: true, show: false },
        { label: '系统', value: 'os', filter: true, show: false },
        { label: '根游戏', value: 'root_game_id', filter: true, show: false },
        { label: '渠道组', value: 'agent_group_id', filter: true, show: false },
        { label: '主游戏', value: 'main_game_id', filter: true, show: false },
        { label: '子游戏', value: 'game_id', filter: true, show: false },
        { label: '负责人', value: 'agent_leader', filter: true, show: false },
        { label: '渠道', value: 'agent_id', filter: true, show: false },
        { label: '广告位', value: 'site_id', filter: true, show: false }
      ],
      analyseDataColumn: [
        { label: '日期', value: 'tdate' },
        { label: '消耗', value: 'cost', sortable: 'custom' },
        { label: '消耗占比', value: 'cost_rate', sortable: 'custom' }
      ],
      analyseList: [
        { label: '首日回本率', value: 'first_day_roi', disabled: false },
        { label: '注册成本', value: 'cost_per_reg', disabled: false },
        { label: '首日付费率', value: 'first_day_pay_percent', disabled: false },
        { label: '首日付费ARPU', value: 'first_day_arppu', disabled: false },
        { label: '首日付费成本', value: 'cost_per_first_day_pay', disabled: false },
        { label: '首日LTV', value: 'first_day_ltv', disabled: false }
      ],
      showChart: false
    }
  },
  watch: {
    exceptionData: {
      deep: true,
      immediate: true,
      handler() {
        this.analyse()
      }
    }
  },
  created() {

  },
  methods: {
    analyse() {
      this.analyseShowDimColumn = {}
      this.analyseColumn = []
      const dimColumn = deepClone(this.analyseDimColumn)
      this.analyseTarget = this.rowData
      this.analyseTarget.cost = this.rowData.cost_money ? this.rowData.cost_money : this.rowData.day_cost_money
      this.analyseTarget.date_min = this.dateMin
      this.analyseTarget.date_max = this.dateMax
      this.analyseTarget = [this.analyseTarget]
      if (Object.prototype.toString.call(this.exceptionData.data.list) === '[object String]') {
        this.hasNotAbnormality = true
        this.analyseTargetTip = this.exceptionData.data.list
      } else {
        this.hasNotAbnormality = false
        let cost = 0
        this.analyseDataList = this.exceptionData.data.list.map((item, index) => {
          // 获取最细维度
          cost += Number(item.cost.split('(')[1].replace(/[\)\%]/g, '')) * 100
          dimColumn.forEach(column => {
            if (!column.show && item.item[column.value]) {
              column.show = true
            }
          })
          const res = item
          res.id = index
          this.expands = this.expands.length === 0 && Object.keys(item.detail).length > 0 ? [index] : this.expands
          return res
        })
        this.allCost = cost / 100 + '%'
        const special = this.searchAnalyseType === 'first_day_pay_percent' || this.searchAnalyseType === 'cost_per_reg' || this.searchAnalyseType === 'first_day_ltv' ? [{ label: '注册数', value: 'reg_uid_count', sortable: 'custom' }] : this.searchAnalyseType === 'first_day_arppu' || this.searchAnalyseType === 'cost_per_first_day_pay' ? [{ label: '首日付费人数', value: 'first_day_pay_count', sortable: 'custom' }] : []
        const analyseData = deepClone(this.analyseList).filter(item => { return item.value === this.searchAnalyseType }).map(i => {
          i.value = i.value === 'first_day_arppu' ? 'first_day_pay_arpu' : i.value === 'first_day_pay_percent' ? 'first_day_pay_rate' : i.value === 'cost_per_reg' ? 'reg_uid_cost_money' : i.value
          i.sortable = 'custom'
          return i
        })
        this.analyseColumn = [].concat(...dimColumn.filter(item => { return item.show }), ...this.analyseDataColumn, ...special, ...analyseData)
        this.showChartMap = {}
      }
      for (const key in this.dimensionColumn) {
        if (this.dimensionColumn[key] !== '日期') {
          this.analyseShowDimColumn[key] = this.dimensionColumn[key]
        }
      }
    },
    handleExpand(row, expandedRows) {
      if (this.expands.indexOf(row.id) > -1) {
        this.expands = []
        analyseTracking(5)
      } else {
        this.expands = [row.id]
        analyseTracking(4)
      }
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'gap') {
        if (row[column.property]) {
          const value = Math.abs(Number(row[column.property].replace('%', '')))
          let color = ''
          if (value >= 50) {
            color = 'differ-class-red'
          }
          if (value < 50 && value >= 30) {
            color = 'differ-class-pink-double'
          }
          if (value < 30 && value >= 20) {
            color = 'differ-class-pink'
          }
          return color
        } else {
          return ''
        }
      }
    },
    handleAnalyseSortChange(data) {
      if (data.column.label === '消耗') {
        this.analyseDataList.sort((a, b) => {
          if (data.order === 'ascending') {
          // 降序
            return this.getDateNumber(a.cost.split('(')[0]) > this.getDateNumber(b.cost.split('(')[0]) ? 1 : -1
          } else {
          // 升序
            return this.getDateNumber(a.cost.split('(')[0]) < this.getDateNumber(b.cost.split('(')[0]) ? 1 : -1
          }
        })
      } else if (data.column.label === '消耗占比') {
        this.analyseDataList.sort((a, b) => {
          if (data.order === 'ascending') {
          // 降序
            return this.getDateNumber(a.cost.split('(')[1].replace(')', '')) > this.getDateNumber(b.cost.split('(')[1].replace(')', '')) ? 1 : -1
          } else {
          // 升序
            return this.getDateNumber(a.cost.split('(')[1].replace(')', '')) < this.getDateNumber(b.cost.split('(')[1].replace(')', '')) ? 1 : -1
          }
        })
      } else if (data.prop === 'gap') {
        this.analyseDataList.sort((a, b) => {
          if (data.order === 'ascending') {
          // 降序
            return this.getDateNumber(a[data.prop]) > this.getDateNumber(b[data.prop]) ? 1 : -1
          } else {
          // 升序
            return this.getDateNumber(a[data.prop]) < this.getDateNumber(b[data.prop]) ? 1 : -1
          }
        })
      } else {
        this.analyseDataList.sort((a, b) => {
          if (data.order === 'ascending') {
          // 降序
            return this.getDateNumber(a.item[data.prop]) > this.getDateNumber(b.item[data.prop]) ? 1 : -1
          } else {
          // 升序
            return this.getDateNumber(a.item[data.prop]) < this.getDateNumber(b.item[data.prop]) ? 1 : -1
          }
        })
      }
    },
    getDateNumber(data) {
      const res = data.replace(/(\-?\d+(\.\d+)?)%/, ($0, $1) => {
        return $1
      })
      return Number(res)
    },
    hasChart(key, item, rowKey) {
      if (['first_day_pay_percent', 'first_day_arppu'].indexOf(key) > -1 && item) {
        this.showChartMap[rowKey] = !this.showChartMap[rowKey] ? key : this.showChartMap[rowKey]
      }
      return this.showChartMap[rowKey] && this.showChartMap[rowKey] === key
    },
    getAnalyseText(str) {
      const res = str.replace(/(老用户无异常|新用户无异常|首日付费率高)/g, ($0, $1) => {
        return `<span style="color: green">${$1}</span>`
      }).replace(/(新用户|老用户)(首日付费率低|首日付费ARPU低)/g, ($0, $1, $2) => {
        return `<span style="color: red">${$1}</span>${$2}`
      })
      const arr = res.split('<br>')
      arr[0] = arr[0].replace(/偏差((\-?\d+(\.\d+)?)\%)/g, ($0, $1, $2) => {
        if (Math.abs(Number($2)) > 20) {
          return `偏差<span style="color: red">${$1}</span>`
        } else {
          return $0
        }
      })
      return arr.join('<br>')
    },
    getDate(rowData) {
      if (rowData.date_min && rowData.date_max) {
        return rowData.date_min === rowData.date_max ? rowData.date_min : rowData.date_min + '至' + rowData.date_max
      }
      return rowData.game_reg_date
    },
    handleShowChart() {
      this.showChart = !this.showChart
      // analyseTracking(6)
    }
  }
}
</script>

<style lang="scss" scoped>
.analyse-container{
	.analyse-btn{
    color: #f40000;
  }
  #analyse-table{
    ::v-deep th {
        height: 26px!important;
      }
    ::v-deep.el-table__body{
      tr {
        height: 32px!important;
      }
      tr:first-child{
        background: none!important;
      }
    }
  }
  .chart-form-item{
    margin-left: 20px;
  }
}
</style>
